import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import { Link } from '@router/Link';

import styles from './styles.module.scss';

function LoginCard() {
  return (
        <Column className={styles.container}
                align='center'
                spacing={12}>
            <Text className={styles.text} align='center'>
                프리미엄 멤버십 & 할인 혜택 이벤트<br/>
                앱에서만 만나보실 수 있어요
            </Text>
            <Link activityParams={{}}
                  activityName='SignInActivity' >
                <Button className={styles.button}>
                    3초만에 로그인
                </Button>
            </Link>
        </Column>
  );
}

export default LoginCard;
